import { render, staticRenderFns } from "./DeliveryReception.vue?vue&type=template&id=b0fdd372&scoped=true"
import script from "./DeliveryReception.vue?vue&type=script&lang=js"
export * from "./DeliveryReception.vue?vue&type=script&lang=js"
import style0 from "./DeliveryReception.vue?vue&type=style&index=0&id=b0fdd372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdd372",
  null
  
)

export default component.exports